<template>
  <div class="report-card">
    <div class="report-card__content">
      <div
        class="report-card__date font-16"
        v-if="_.get(product, 'content_type') !== 'proposal'"
      >
        {{ formatDate(product.date) }}
      </div>

      <a
        v-if="_.get(product, 'link.title')"
        class="report-card__title font-24 tbc-bold text-overflow--line2"
        :target="_.get(product, 'title.url_target') == 1 ? '_blank' : ''"
        :href="_.get(product, `link.url`)"
      >
        {{ product.title }}
      </a>
      <div
        v-else
        class="report-card__title font-24 tbc-bold text-overflow--line2"
      >
        {{ product.title }}
      </div>
      <div
        class="report-card__desc tbc-regular font-18 lh-27 text-overflow--line4"
      >
        {{ product.teaser }}
      </div>
    </div>
    <div
      class="report-card__reports"
      v-if="_.get(product, 'moreLink.title') || _.get(product, 'link.title')"
    >
      <div class="view-more animated-link animated-link-a flex-box al-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
        >
          <path
            id="Combined_Shape_Copy_2"
            data-name="Combined Shape Copy 2"
            d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
            transform="translate(0 0)"
            fill="#00aeef"
          />
        </svg>

        <a
          class="flex-box uppercase"
          :target="_.get(product, 'title.url_target') == 1 ? '_blank' : ''"
          :href="_.get(product, `link.url`) || _.get(product, 'moreLink.url')"
        >
          {{ _.get(product, "moreLink.title") || _.get(product, "link.title") }}
        </a>
      </div>
    </div>
    <div class="report-card__reports" v-else>
      <div class="title font-16">{{ $fn.tr("Report") }}</div>
      <a
        :href="_.get(product, 'file_ge[0].url')"
        target="_blank"
        class="lang font-16"
      >
        {{ $fn.tr("Geo") }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.33"
          height="14.331"
          viewBox="0 0 14.33 14.331"
        >
          <g
            id="Group_5886"
            data-name="Group 5886"
            transform="translate(-433.841 -3160.408)"
          >
            <g
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              transform="translate(448.171 3160.408) rotate(90)"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.321,13.981a1.194,1.194,0,0,1,0-1.689l3.933-3.933H1.194a1.194,1.194,0,0,1,0-2.389h9.058L6.321,2.039A1.194,1.194,0,0,1,8.009.35l5.971,5.97L14,6.342l.01.011.01.011.012.014.007.008.013.016.005.006.014.017,0,.005.014.018,0,0,.014.019,0,0,.013.019,0,.006.012.018,0,.007.01.017.006.009.009.014.007.012.006.011.009.017,0,.008.011.021v0a1.194,1.194,0,0,1-.245,1.391L8.009,13.981a1.194,1.194,0,0,1-1.689,0Z"
                transform="translate(0 0)"
                fill="#00a3e0"
              />
            </g>
          </g>
        </svg>
      </a>
      <a
        :href="_.get(product, 'file_en[0].url')"
        target="_blank"
        class="lang font-16"
      >
        {{ $fn.tr("Eng") }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.33"
          height="14.331"
          viewBox="0 0 14.33 14.331"
        >
          <g
            id="Group_5886"
            data-name="Group 5886"
            transform="translate(-433.841 -3160.408)"
          >
            <g
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              transform="translate(448.171 3160.408) rotate(90)"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.321,13.981a1.194,1.194,0,0,1,0-1.689l3.933-3.933H1.194a1.194,1.194,0,0,1,0-2.389h9.058L6.321,2.039A1.194,1.194,0,0,1,8.009.35l5.971,5.97L14,6.342l.01.011.01.011.012.014.007.008.013.016.005.006.014.017,0,.005.014.018,0,0,.014.019,0,0,.013.019,0,.006.012.018,0,.007.01.017.006.009.009.014.007.012.006.011.009.017,0,.008.011.021v0a1.194,1.194,0,0,1-.245,1.391L8.009,13.981a1.194,1.194,0,0,1-1.689,0Z"
                transform="translate(0 0)"
                fill="#00a3e0"
              />
            </g>
          </g>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["product"],
  methods: {
    formatDate(date) {
      return moment(date).format("D MMM, YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
.report-card {
  border-radius: 6px;
  border: 1px solid #364756;
  padding: 30px;
  width: 100%;
  height: 377px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 1399px) {
    // width: 450px;
  }
  @media (max-width: 1023px) {
    padding: 20px;
  }
  @media (max-width: 767px) {
    // width: 279px;
    padding: 20px;
    height: 324px;
  }
  @media (max-width: 413px) {
    // width: 208px;
  }
  &__date {
    color: var(--secondary);
    margin-bottom: 22px;
  }
  &__title {
    line-height: 36px;
    color: var(--secondary);
    margin-top: 22px;
    min-height: 60px;
    height: 70px;
    margin-bottom: 21px;
    cursor: pointer;
    transition: 0.4s ease;
    @media (min-width: 1025px) {
      &:hover {
        color: var(--tbc-blue);
      }
    }
    @media (max-width: 1399px) {
      font-size: 24px;
      margin-bottom: 30px;
    }
    @media (max-width: 767px) {
      min-height: 45px;
      height: 45px;
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 22px;
    }
  }
  &__reports {
    display: flex;
    .title {
      color: var(--secondary);
      margin-right: 15px;
    }
    .lang {
      color: var(--tbc-blue);
      margin-right: 15px;
      display: flex;
      cursor: pointer;
      svg {
        margin-left: 7px;
      }
    }
  }
  &__desc {
    margin-top: 22px;
    @media (max-width: 413px) {
      font-size: 16px;
    }
  }
}
html[lang="ge"] .report-card__title {
  text-transform: uppercase;
  -moz-font-feature-settings: "case";
  -webkit-font-feature-settings: "case";
  font-feature-settings: "case" on;
}
</style>
